<template lang="pug">

  form-group-row(v-if='countries', :form='form', :label="label", name="country")
    v-select.form-control(v-model="country", label="value", :options="countries", :searchable="true", :class="{'is-invalid': form.errors.has('country')}")

</template>

<script>

import TextInput from './TextInput'
import countries from 'country-list';

export default {
  name: 'user-input-country',

  components: {
    TextInput,
  },

  props: {
    label: {
      type: String,
      default: 'Country',
    },
    default: {
      type: String,
      default: null,
    }
  },

  data: () => ({
    form: null,
    country: null,
    countries: null,
  }),

  watch: {
    country(val) {
      this.$set(this.form, 'country', val ? val.value : null);
    }
  },

  async created() {
    this.form = this.$parent.form;
    this.country = { value: this.$parent.user ? this.$parent.user.meta.country : this.default };
    this.countries = await countries().getNames().map(x => ({value: x}));
  },
}

</script>
